"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeLogStreamType = void 0;
var IkeLogStreamType;
(function (IkeLogStreamType) {
    IkeLogStreamType["CONSOLE"] = "stream-console";
    IkeLogStreamType["LOG_ENTRIES"] = "stream-logentries";
    IkeLogStreamType["LOG_ENTRIES_POST"] = "stream-logentries-post";
})(IkeLogStreamType || (exports.IkeLogStreamType = IkeLogStreamType = {}));
//# sourceMappingURL=log.streams.js.map